module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: ['nav-item', 'dropdown', {
      dropup: _vm.dropup,
      show: _vm.visible
    }]
  }, [_c('a', {
    ref: "button",
    class: ['nav-link', _vm.dropdownToggle, {
      disabled: _vm.disabled
    }],
    attrs: {
      "href": "",
      "aria-haspopup": "true",
      "aria-expanded": _vm.visible,
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.toggle($event)
      }
    }
  }, [_vm._t("text", [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])], 2), _vm._v(" "), _c('div', {
    ref: "menu",
    class: ['dropdown-menu', {
      'dropdown-menu-right': _vm.right
    }],
    attrs: {
      "role": "menu",
      "aria-labelledby": 'b_dropdown_button_' + _vm._uid
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.onEsc($event)
      },
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
        _vm.onTab($event)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "up", 38)) { return null; }
        _vm.focusNext($event, true)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "down", 40)) { return null; }
        _vm.focusNext($event, false)
      }]
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15e722dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/bootstrap-vue/components/nav-item-dropdown.vue
// module id = 226
// module chunks = 0